import { LoanType, PoolDocument } from '@/types/pool';
import { DEFAULT_COUNTRY_CODE } from './consts';

export const formatCurrency = (amount: string | number | null | undefined): string => {
  if (!amount) return '$0';
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(num);
};

export const formatDateToShortString = (dateISOString: string | undefined): string => {
  if (!dateISOString) return '--';
  return new Date(dateISOString).toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  });
};

export const formatPercentage = (value: string | number | undefined): string => {
  if (!value) return '0%';
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) return '0%';
  return `${num}%`;
};

export const getPhoneWithCountryCode = (phone: string, countryCode: string) => {
  return phone ? `${countryCode}${phone.replace(/\D/g, '')}` : '';
};

export const separatePhoneNumberFromCountryCode = (phone: string): { phoneNumber: string; countryCode: string } => {
  // NOTE: THIS function always assumes we are using US phone numbers and country code is DEFAULT_COUNTRY_CODE always
  if (!phone) return { phoneNumber: '', countryCode: DEFAULT_COUNTRY_CODE };
  if (!phone.startsWith('+')) {
    // If phone number does not start with +, add the country code
    // assume the phone number is in the format of 1234567890
    return { phoneNumber: phone, countryCode: DEFAULT_COUNTRY_CODE };
  }
  // If phone number starts with +, remove the country code
  // and return the phone number and country code
  // the country code is the first 2 characters of the phone number
  return { phoneNumber: phone.slice(2), countryCode: phone.slice(0, 2) };
};

export const LoanTypeLabel: Record<LoanType, string> = {
  [LoanType.INTEREST_ONLY]: 'Interest-Only',
  [LoanType.AMORTIZING]: 'Amortizing',
};

export const extractFilename = (doc: PoolDocument): string => {
  if (doc.name) {
    return doc.name;
  }
  return doc.key.split('/').pop() || 'Document';
};
